import {ContentStatus} from "../../constant/CodeSpecNum";

function maintenanceAssetNameRenderer({data}){
    
    if(data){
        const length = data.length;
        if(length > 0) {
            const str = data.length <= 1 ? data[0].assets?.assetName : (data[0].assets?.assetName + " 외 " + (length - 1) + "개");
            return(
                str
            )
        }else{
            return (
                ""
            )
        }
    }
}

function connectedNameRenderer({data}){
    if(data){
        return data === "INSPECTION" ? "점검" : data === "INCIDENT" ? "장애" : data === "SERVICE_REQUEST" ? "서비스접수" : ""
    }
}

function progressNameRenderer({data}){
    if(data){
        return data.rejected === "NONE" ? data.statusKorValue : data.statusNumericValue === ContentStatus.POST_APPROVE.statusNumericValue ? "반려(사후결재)" : "반려(사전결재)"
    }
}

function progressDailyCheckNameRenderer({data}){
    if(data){
        return data.rejected === "NONE" ? data.statusKorValue : "반려"
    }
}

export {maintenanceAssetNameRenderer, connectedNameRenderer, progressNameRenderer, progressDailyCheckNameRenderer}